<template>
  <div>
    <h2>个人信息</h2>
    <div class="content">
      <el-button
        v-if="this.disabled === false"
        type="primary"
        plain
        size="small"
        icon="el-icon-edit"
        style="float:right"
        @click="disabled = true"
      >编辑</el-button>
      <h3>基本信息</h3>
      <el-form
        label-position="right"
        label-width="160px"
        :model="infoFormDate"
        style="width: 700px"
        ref="infoFormDate"
        :rules="rules"
        :disabled="!disabled"
      >
        <!-- <el-form-item label="头像：" class="upload_img">
          <img-upload  @setNewUrl="getImg" :imgUrl="posiImg" ></img-upload>
        </el-form-item> -->
        <el-form-item label="姓名：" prop="realName">
          <el-input v-model="infoFormDate.realName" placeholder="请输入姓名" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <el-radio-group v-model="infoFormDate.sex">
            <!-- <el-radio :label="0">保密</el-radio> -->
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄：" prop="age">
          <el-input  min="0" v-model="infoFormDate.age" placeholder="请输入年龄" maxlength="3"></el-input>
        </el-form-item>

          <el-form-item label="身份证号：" prop="idCard" v-if="!disabled">
          <el-input :value="infoFormDate.idCard | formatData" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="idCard" v-else>
          <el-input v-model="infoFormDate.idCard" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
        <el-form-item label="身份证号所在地区：" required>
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="0" prop="provinceCode">
                <el-select
                  v-model="infoFormDate.provinceCode"
                  placeholder="请选择省"
                  @change="city(false)"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="0" prop="cityCode">
                <el-select
                  v-model="infoFormDate.cityCode"
                  placeholder="请选择市"
                  @change="district(false)"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" label-width="0" prop="districtCode">
              <el-form-item>
                <el-select v-model="infoFormDate.districtCode" placeholder="请选择县/区">
                  <el-option
                    v-for="item in districtList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="身份证详细住址：" prop="idCardAddress">
          <el-input v-model="infoFormDate.idCardAddress" placeholder="请输入身份证详细地址" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="现居住住址：" prop="residentialAddress">
          <el-input v-model="infoFormDate.residentialAddress" placeholder="请输入现居住住址" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="公司单位信息：">
          <el-input v-model="infoFormDate.companyInfo" placeholder="请输入公司单位信息" maxlength="500"></el-input>
        </el-form-item>
        <h3>其他信息</h3>

         <el-form-item label="手机号：" v-if="!disabled">
          <el-input :value="infoFormDate.mobile | formatData" placeholder="请输入手机号" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号：" v-else>
          <el-input v-model="infoFormDate.mobile" placeholder="请输入手机号" disabled></el-input>
        </el-form-item>
        <!-- <el-form-item label="邮箱：">
          <el-input v-model="infoFormDate.email" placeholder="请输入邮箱" disabled></el-input>
        </el-form-item>-->
        <el-form-item v-if="this.disabled === true">
          <el-button type="primary" @click="submit">保 存</el-button>
          <el-button @click="disabled = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
// import ImgUpload from '@/components/img-upload'
import reg from '@/utils/regular.js'
export default {
  data() {
    // let checkPhone = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入手机号'))
    //   }
    //   if (!reg.phone.test(value)) {
    //     callback(new Error('请输入正确的手机号'))
    //   }
    //   callback()
    // }
    let checkIdCard = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入身份证号'))
      }
      if (!reg.idNumber.test(value)) {
        callback(new Error('请输入正确的身份证号'))
      }
      callback()
    }
    let checkEmail = (rule, value, callback) => {
      if (value) {
        if (!reg.email.test(value)) {
          callback(new Error('请输入正确的邮箱'))
        }
        callback()
      }
      callback()
    }

    let validateNum = (rule, value, callback) => {
        if (!reg.isZheng.test(value)) {
          callback(new Error("请输入正整数"));
        }
        callback();
      };
    return {
      rules: {
        // mobile: [{ required: true, validator: checkPhone, trigger: 'blur' }],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        age: [{ required: true,validator: validateNum , trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
        idCard: [{ required: true, validator: checkIdCard, trigger: 'blur' }],
        provinceCode: [{ required: true, message: '请选择省', trigger: 'blur' }],
        cityCode: [{ required: true, message: '请选择市', trigger: 'blur' }],
        districtCode: [{ required: true, message: '请选择区/县', trigger: 'blur' }],
        idCardAddress: [{ required: true, message: '请输入身份证详细地址', trigger: 'blur' }],
        residentialAddress: [{ required: true, message: '请输入现居住住址', trigger: 'blur' }],
        email: [{ validator: checkEmail, trigger: 'blur' }]
      },
      currentIndex: 1,
      infoFormDate: {
        avatarUrl: '',
        mobile: '',
        email: '',
        realName: '',
        sex: '',
        age: '',
        idCard: '',
        idCardAddress: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        residentialAddress: '',
        companyInfo: ''
      },
      disabled: false,
      provinceList: [],
      cityList: [],
      districtList: [],
      posiImg:""
    }
  },
  components: {
    // ImgUpload
  },
  created() {
    this.getUserInfo()
    this.province(false)
  },
  methods: {
    // 上传之后获取图片信息
    getImg(val){
      console.log(val);
      this.infoFormDate.avatarUrl =val
    },
    // 获取用户信息
    getUserInfo() {
      this.$store.dispatch('user/getInfo').then(res => {
        this.infoFormDate = res
        // this.infoFormDate.avatarUrl =this.infoFormDate.url
        this.infoFormDate.avatarUrl =res.avatarUrl
        this.posiImg =res.url
        // console.log(333,this.posiImg);
        
        if (this.infoFormDate.cityCode) {
          this.city(true)
        }
        if (this.infoFormDate.districtCode) {
          this.district(true)
        }
      })
    },
    // 获取省
    province() {
      this.$request({
        url: '/api/web/region/list',
        method: 'get',
        params: {}
      }).then(res => {
        this.provinceList = res.data
      })
    },
    // 获取市
    city(init) {
      if (!init) {
        this.infoFormDate.cityCode = ''
        this.infoFormDate.districtCode = ''
      }
      this.$request({
        url: '/api/web/region/list',
        method: 'get',
        params: { pid: this.infoFormDate.provinceCode, treeLevel: 2 }
      }).then(res => {
        this.cityList = res.data
      })
    },
    // 获取区
    district(init) {
      if (!init) {
        this.infoFormDate.districtCode = ''
      }
      this.$request({
        url: '/api/web/region/list',
        method: 'get',
        params: { pid: this.infoFormDate.cityCode, treeLevel: 3 }
      }).then(res => {
        this.districtList = res.data
      })
    },
    // 更新个人信息
    submit() {
      this.$refs.infoFormDate.validate(valid => {
        if (valid) {
          this.infoFormDate.province=this.infoFormDate.provinceCode?this.provinceList.filter(item=>item.id==this.infoFormDate.provinceCode)[0].name:""
          this.infoFormDate.city=this.infoFormDate.cityCode?this.cityList.filter(item=>item.id==this.infoFormDate.cityCode)[0].name:""
          this.infoFormDate.district=this.infoFormDate.districtCode?this.districtList.filter(item=>item.id==this.infoFormDate.districtCode)[0].name:""

          const params = { ...this.infoFormDate }
          this.$request({
            url: '/api/web/usercore/update',
            method: 'post',
            data: params
          }).then(() => {
            this.$message.success('更新成功')
            this.disabled = false
            this.$store.dispatch('user/getInfo')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  padding: 20px 40px;
}
</style>